import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskNotificationsNotificationEmailRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-notifications-notification-email',
	path: '/jira/servicedesk/projects/:projectKey/settings/notifications/notification-email',
	exact: true,
};
